import Victoria1 from "./victoria (1).webp";
import Victoria2 from "./victoria (2).webp";
import Victoria3 from "./victoria (3).webp";
import Victoria4 from "./victoria (4).webp";

const victoria = [Victoria1, Victoria2, Victoria3, Victoria4];

export default victoria;
